function processFindItem (stickyList) {
  let foundItem = null;

  for (let i = 0; i < stickyList.length; i++) {
    const item = stickyList[i];

    if (item.isSticky === false) {
      foundItem = stickyList[i - 1] || null;
      break;
    }
  }

  return foundItem;
}

/**
 * Finds the first element with `isSticky: false` in the list and returns the previous element with `isSticky: true`.
 * If the first element in the list is `isSticky: false`, or if no previous `true` element exists, returns `null`.
 * @param {Array} stickyList - An array of objects,
 * where each object has the `isSticky` property indicating sticky state.
 * @returns {Object | null} - Returns the previous object with `isSticky: true` before the first `false` element,
 * or null if no such element exists.
 */
export default function findNextStickyAfterFalse (stickyList = []) {

  return processFindItem(stickyList);
}
